export const createFragment = function(obj) {
  return React.createElement(React.Fragment, null, Object.keys(obj).map(
    (key) => React.createElement(React.Fragment, { key: key }, obj[key])
  ))
};

export default createFragment;
